export * from './vorlage-post-request.interface';
export * from './vorlage-post-response.interface';
export * from './vorlage-post.shapes';
